// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._V8j50ws12gizfHzCav0{align-items:center;gap:8px;display:flex}.x0cRomFj1Vsdy7M5_6sI{margin-left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxRow": `_V8j50ws12gizfHzCav0`,
	"primaryTooltip": `x0cRomFj1Vsdy7M5_6sI`
};
export default ___CSS_LOADER_EXPORT___;
